import { createSlice, PayloadAction } from '@reduxjs/toolkit';



interface ThemeState {
  primaryColor: string;
  secondaryColor: '#2C3E50' | '#4A4A4A' | '#4682B4' | '#008080' | '#D35400' | '#6A0DAD';
  fontColor: string;
}

const initialState: ThemeState = {
  primaryColor: 'violet',
  secondaryColor: '#008080',
  fontColor: '#000000',
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setPrimaryColor(state, action: PayloadAction<string>) {
      state.primaryColor = action.payload;
    },
    setSecondaryColor(state, action: PayloadAction<'#2C3E50' | '#4A4A4A' | '#4682B4' | '#008080' | '#D35400' | '#6A0DAD'>) {
      state.secondaryColor = action.payload;
    },
    setFontColor(state, action: PayloadAction<string>) {
      state.fontColor = action.payload;
    },
    setThemeColors(
      state,
      action: PayloadAction<ThemeState>
    ) {
      state.primaryColor = action.payload.primaryColor;
      state.secondaryColor = action.payload.secondaryColor;
      state.fontColor = action.payload.fontColor;
    },
  },
});

export const { setPrimaryColor, setSecondaryColor, setFontColor, setThemeColors } = themeSlice.actions;
export default themeSlice.reducer;
